var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmurgo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 55,
    viewBox: "0 0 220 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.816 34.4383C205.705 34.4383 204.678 34.1658 203.777 33.6418C202.875 33.1177 202.142 32.3632 201.618 31.399C201.094 30.4348 200.821 29.3239 200.821 28.0873C200.821 26.8506 201.094 25.7397 201.618 24.7755C202.142 23.8113 202.854 23.0777 203.777 22.5328C204.678 22.0087 205.705 21.7363 206.816 21.7363C207.927 21.7363 208.954 22.0087 209.855 22.5328C210.756 23.0568 211.49 23.8113 212.014 24.7755C212.538 25.7397 212.811 26.8506 212.811 28.0873C212.811 29.3449 212.538 30.4348 212.014 31.399C211.49 32.3632 210.756 33.0968 209.855 33.6418C208.954 34.1867 207.927 34.4383 206.816 34.4383ZM206.816 39.6364C209.163 39.6364 211.28 39.1334 213.146 38.1482C215.011 37.1631 216.479 35.7797 217.548 34.019C218.617 32.2584 219.141 30.2881 219.141 28.0873C219.141 25.8864 218.617 23.9161 217.548 22.1555C216.479 20.3948 215.011 19.0324 213.146 18.0263C211.28 17.0411 209.163 16.5381 206.816 16.5381C204.468 16.5381 202.351 17.0411 200.486 18.0263C198.62 19.0114 197.153 20.3948 196.084 22.1555C195.015 23.9161 194.491 25.8864 194.491 28.0873C194.491 30.2881 195.015 32.2584 196.084 34.019C197.153 35.7797 198.62 37.1421 200.486 38.1482C202.351 39.1543 204.468 39.6364 206.816 39.6364ZM184.304 33.7046C183.256 34.1867 182.125 34.4383 180.909 34.4383C179.693 34.4383 178.603 34.1658 177.639 33.6208C176.696 33.0758 175.941 32.3422 175.417 31.378C174.893 30.4139 174.621 29.3239 174.621 28.0873C174.621 26.1589 175.208 24.6288 176.361 23.476C177.513 22.3232 179.064 21.7572 180.951 21.7572C183.047 21.7572 184.849 22.5747 186.338 24.2305L190.341 20.6254C189.251 19.3049 187.868 18.3197 186.212 17.6071C184.556 16.9154 182.711 16.559 180.636 16.559C178.268 16.559 176.151 17.0411 174.264 18.0263C172.378 19.0114 170.911 20.3738 169.863 22.1345C168.815 23.8952 168.27 25.8864 168.27 28.0873C168.27 30.3091 168.794 32.3003 169.863 34.04C170.911 35.8007 172.378 37.1631 174.244 38.1482C176.109 39.1334 178.205 39.6155 180.532 39.6155C182.187 39.6155 183.822 39.3639 185.478 38.8819C187.134 38.3998 188.58 37.7081 189.859 36.7858V27.5842H184.304V33.7046ZM157.664 25.2157C157.664 26.2427 157.328 27.0602 156.679 27.6052C156.029 28.1711 155.044 28.4436 153.765 28.4436H150.286V21.9459H153.765C155.044 21.9459 156.029 22.2393 156.679 22.8052C157.328 23.3712 157.664 24.1886 157.664 25.2157ZM157.727 39.1963H164.455L159.676 32.2165C161.08 31.5457 162.149 30.6025 162.904 29.4078C163.659 28.213 164.036 26.8087 164.036 25.2157C164.036 23.5389 163.638 22.0926 162.841 20.8559C162.045 19.6193 160.892 18.676 159.425 18.0053C157.936 17.3346 156.197 16.9992 154.184 16.9992H143.998V39.1963H150.286V33.3064H153.702L157.727 39.1963ZM127.418 39.6364C130.709 39.6364 133.287 38.7351 135.111 36.9325C136.934 35.1299 137.856 32.5937 137.856 29.282V16.9992H131.673V29.1143C131.673 32.6566 130.269 34.4383 127.481 34.4383C124.672 34.4383 123.268 32.6566 123.268 29.1143V16.9992H116.98V29.303C116.98 32.5937 117.902 35.1509 119.726 36.9535C121.549 38.7351 124.127 39.6364 127.418 39.6364ZM110.838 39.1963V16.9992H105.661L98.0526 29.806L90.2553 16.9992H85.0991V39.1963H90.9051V27.7519L96.5854 37.0164H99.3521L105.053 27.4375V39.1963H110.838ZM67.9745 34.3544V30.2881H77.8258V25.593H67.9745V21.862H79.1673V16.9992H61.7702V39.1963H79.5865V34.3544H67.9745Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2946 14.9868C41.0613 14.9868 43.3041 12.744 43.3041 9.97731C43.3041 7.21062 41.0613 4.96777 38.2946 4.96777C35.5279 4.96777 33.2851 7.21062 33.2851 9.97731C33.2851 12.744 35.5279 14.9868 38.2946 14.9868Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4272 25.7187C48.9624 25.7187 51.0176 23.6636 51.0176 21.1284C51.0176 18.5932 48.9624 16.5381 46.4272 16.5381C43.8921 16.5381 41.8369 18.5932 41.8369 21.1284C41.8369 23.6636 43.8921 25.7187 46.4272 25.7187Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4273 39.6362C48.7309 39.6362 50.5984 37.7687 50.5984 35.4651C50.5984 33.1614 48.7309 31.2939 46.4273 31.2939C44.1236 31.2939 42.2562 33.1614 42.2562 35.4651C42.2562 37.7687 44.1236 39.6362 46.4273 39.6362Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2946 50.3681C40.3667 50.3681 42.0465 48.6883 42.0465 46.6162C42.0465 44.544 40.3667 42.8643 38.2946 42.8643C36.2225 42.8643 34.5427 44.544 34.5427 46.6162C34.5427 48.6883 36.2225 50.3681 38.2946 50.3681Z",
    fill: "url(#paint3_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.88 54.3295C26.7206 54.3295 28.2127 52.8374 28.2127 50.9968C28.2127 49.1562 26.7206 47.6641 24.88 47.6641C23.0394 47.6641 21.5473 49.1562 21.5473 50.9968C21.5473 52.8374 23.0394 54.3295 24.88 54.3295Z",
    fill: "url(#paint4_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4864 49.5296C13.0954 49.5296 14.3999 48.2252 14.3999 46.6161C14.3999 45.007 13.0954 43.7026 11.4864 43.7026C9.87729 43.7026 8.57288 45.007 8.57288 46.6161C8.57288 48.2252 9.87729 49.5296 11.4864 49.5296Z",
    fill: "url(#paint5_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35372 37.9593C4.73127 37.9593 5.848 36.8425 5.848 35.465C5.848 34.0874 4.73127 32.9707 3.35372 32.9707C1.97616 32.9707 0.859436 34.0874 0.859436 35.465C0.859436 36.8425 1.97616 37.9593 3.35372 37.9593Z",
    fill: "url(#paint6_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3537 23.2034C4.49973 23.2034 5.42878 22.2743 5.42878 21.1283C5.42878 19.9823 4.49973 19.0532 3.3537 19.0532C2.20767 19.0532 1.27863 19.9823 1.27863 21.1283C1.27863 22.2743 2.20767 23.2034 3.3537 23.2034Z",
    fill: "url(#paint7_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4864 11.633C12.4009 11.633 13.1422 10.8917 13.1422 9.97716C13.1422 9.06265 12.4009 8.32129 11.4864 8.32129C10.5719 8.32129 9.83051 9.06265 9.83051 9.97716C9.83051 10.8917 10.5719 11.633 11.4864 11.633Z",
    fill: "url(#paint8_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.88 11.025C27.8782 11.025 30.3088 8.59442 30.3088 5.59622C30.3088 2.59801 27.8782 0.16748 24.88 0.16748C21.8818 0.16748 19.4513 2.59801 19.4513 5.59622C19.4513 8.59442 21.8818 11.025 24.88 11.025Z",
    fill: "url(#paint9_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8808 22.2176C33.4088 22.2176 34.6476 20.9789 34.6476 19.4509C34.6476 17.9228 33.4088 16.6841 31.8808 16.6841C30.3527 16.6841 29.114 17.9228 29.114 19.4509C29.114 20.9789 30.3527 22.2176 31.8808 22.2176Z",
    fill: "url(#paint10_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3872 28.1495C37.7879 28.1495 38.9234 27.014 38.9234 25.6133C38.9234 24.2126 37.7879 23.0771 36.3872 23.0771C34.9865 23.0771 33.851 24.2126 33.851 25.6133C33.851 27.014 34.9865 28.1495 36.3872 28.1495Z",
    fill: "url(#paint11_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3872 35.8837C37.6606 35.8837 38.6929 34.8515 38.6929 33.5781C38.6929 32.3047 37.6606 31.2725 36.3872 31.2725C35.1139 31.2725 34.0816 32.3047 34.0816 33.5781C34.0816 34.8515 35.1139 35.8837 36.3872 35.8837Z",
    fill: "url(#paint12_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8808 41.8157C33.0268 41.8157 33.9559 40.8866 33.9559 39.7406C33.9559 38.5946 33.0268 37.6655 31.8808 37.6655C30.7348 37.6655 29.8057 38.5946 29.8057 39.7406C29.8057 40.8866 30.7348 41.8157 31.8808 41.8157Z",
    fill: "url(#paint13_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4608 44.0162C25.4795 44.0162 26.3054 43.1904 26.3054 42.1717C26.3054 41.153 25.4795 40.3271 24.4608 40.3271C23.4421 40.3271 22.6163 41.153 22.6163 42.1717C22.6163 43.1904 23.4421 44.0162 24.4608 44.0162Z",
    fill: "url(#paint14_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0198 41.3544C17.9112 41.3544 18.6338 40.6318 18.6338 39.7404C18.6338 38.8491 17.9112 38.1265 17.0198 38.1265C16.1285 38.1265 15.4059 38.8491 15.4059 39.7404C15.4059 40.6318 16.1285 41.3544 17.0198 41.3544Z",
    fill: "url(#paint15_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5134 34.9616C13.2774 34.9616 13.8968 34.3422 13.8968 33.5782C13.8968 32.8142 13.2774 32.1948 12.5134 32.1948C11.7494 32.1948 11.13 32.8142 11.13 33.5782C11.13 34.3422 11.7494 34.9616 12.5134 34.9616Z",
    fill: "url(#paint16_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5134 26.7661C13.1501 26.7661 13.6662 26.25 13.6662 25.6133C13.6662 24.9766 13.1501 24.4604 12.5134 24.4604C11.8767 24.4604 11.3606 24.9766 11.3606 25.6133C11.3606 26.25 11.8767 26.7661 12.5134 26.7661Z",
    fill: "url(#paint17_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0198 20.3728C17.5292 20.3728 17.9421 19.9599 17.9421 19.4506C17.9421 18.9412 17.5292 18.5283 17.0198 18.5283C16.5105 18.5283 16.0976 18.9412 16.0976 19.4506C16.0976 19.9599 16.5105 20.3728 17.0198 20.3728Z",
    fill: "url(#paint18_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4608 20.0381C26.1278 20.0381 27.4791 18.6867 27.4791 17.0198C27.4791 15.3528 26.1278 14.0015 24.4608 14.0015C22.7938 14.0015 21.4425 15.3528 21.4425 17.0198C21.4425 18.6867 22.7938 20.0381 24.4608 20.0381Z",
    fill: "url(#paint19_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6678 26.3888C28.3624 26.3888 28.9255 25.8257 28.9255 25.1312C28.9255 24.4366 28.3624 23.8735 27.6678 23.8735C26.9733 23.8735 26.4102 24.4366 26.4102 25.1312C26.4102 25.8257 26.9733 26.3888 27.6678 26.3888Z",
    fill: "url(#paint20_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.701 29.0718C30.3377 29.0718 30.8538 28.5556 30.8538 27.9189C30.8538 27.2822 30.3377 26.7661 29.701 26.7661C29.0643 26.7661 28.5482 27.2822 28.5482 27.9189C28.5482 28.5556 29.0643 29.0718 29.701 29.0718Z",
    fill: "url(#paint21_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7009 32.5516C30.2797 32.5516 30.7489 32.0824 30.7489 31.5036C30.7489 30.9248 30.2797 30.4556 29.7009 30.4556C29.1221 30.4556 28.6529 30.9248 28.6529 31.5036C28.6529 32.0824 29.1221 32.5516 29.7009 32.5516Z",
    fill: "url(#paint22_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6678 35.2341C28.1887 35.2341 28.611 34.8118 28.611 34.2909C28.611 33.7699 28.1887 33.3477 27.6678 33.3477C27.1469 33.3477 26.7246 33.7699 26.7246 34.2909C26.7246 34.8118 27.1469 35.2341 27.6678 35.2341Z",
    fill: "url(#paint23_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3351 36.2193C24.7981 36.2193 25.1735 35.8439 25.1735 35.3809C25.1735 34.9179 24.7981 34.5425 24.3351 34.5425C23.872 34.5425 23.4966 34.9179 23.4966 35.3809C23.4966 35.8439 23.872 36.2193 24.3351 36.2193Z",
    fill: "url(#paint24_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9814 35.0248C21.3866 35.0248 21.715 34.6964 21.715 34.2912C21.715 33.8861 21.3866 33.5576 20.9814 33.5576C20.5763 33.5576 20.2478 33.8861 20.2478 34.2912C20.2478 34.6964 20.5763 35.0248 20.9814 35.0248Z",
    fill: "url(#paint25_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9483 32.1321C19.2956 32.1321 19.5771 31.8506 19.5771 31.5033C19.5771 31.156 19.2956 30.8745 18.9483 30.8745C18.601 30.8745 18.3195 31.156 18.3195 31.5033C18.3195 31.8506 18.601 32.1321 18.9483 32.1321Z",
    fill: "url(#paint26_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9483 28.4426C19.2377 28.4426 19.4723 28.2079 19.4723 27.9185C19.4723 27.6291 19.2377 27.3945 18.9483 27.3945C18.6589 27.3945 18.4243 27.6291 18.4243 27.9185C18.4243 28.2079 18.6589 28.4426 18.9483 28.4426Z",
    fill: "url(#paint27_linear)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9814 25.5503C21.2129 25.5503 21.4006 25.3626 21.4006 25.1311C21.4006 24.8996 21.2129 24.7119 20.9814 24.7119C20.7499 24.7119 20.5622 24.8996 20.5622 25.1311C20.5622 25.3626 20.7499 25.5503 20.9814 25.5503Z",
    fill: "url(#paint28_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M24.335 25.404C25.0875 25.404 25.6974 24.7941 25.6974 24.0416C25.6974 23.2892 25.0875 22.6792 24.335 22.6792C23.5826 22.6792 22.9726 23.2892 22.9726 24.0416C22.9726 24.7941 23.5826 25.404 24.335 25.404Z",
    fill: "url(#paint29_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 3.63828,
    y1: 44.6324,
    x2: 42.4689,
    y2: 5.80159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 13.1934,
    y1: 54.3547,
    x2: 52.0239,
    y2: 15.5239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 20.3043,
    y1: 61.59,
    x2: 59.1349,
    y2: 22.7593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 21.7951,
    y1: 63.1078,
    x2: 60.6256,
    y2: 24.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 17.3217,
    y1: 58.5569,
    x2: 56.1524,
    y2: 19.7261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 8.50789,
    y1: 49.5895,
    x2: 47.3384,
    y2: 10.7587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: -1.04737,
    y1: 39.867,
    x2: 37.7832,
    y2: 1.03623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: -8.15897,
    y1: 32.6308,
    x2: 30.6715,
    y2: -6.19995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: -9.6507,
    y1: 31.1121,
    x2: 29.1799,
    y2: -7.71869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: -5.176,
    y1: 35.6641,
    x2: 33.6546,
    y2: -3.16672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 5.15472,
    y1: 46.1753,
    x2: 43.9853,
    y2: 7.34454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 10.4499,
    y1: 51.5632,
    x2: 49.2804,
    y2: 12.7324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 14.3907,
    y1: 55.5729,
    x2: 53.2213,
    y2: 16.7422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 15.2168,
    y1: 56.4141,
    x2: 54.0475,
    y2: 17.5833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 12.7379,
    y1: 53.8918,
    x2: 51.5684,
    y2: 15.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 7.8533,
    y1: 48.9223,
    x2: 46.6838,
    y2: 10.0915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 2.55803,
    y1: 43.5346,
    x2: 41.3886,
    y2: 4.70383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: -1.38299,
    y1: 39.5244,
    x2: 37.4476,
    y2: 0.693747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: -2.20975,
    y1: 38.6825,
    x2: 36.6208,
    y2: -0.14819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 0.270026,
    y1: 41.2058,
    x2: 39.1006,
    y2: 2.37503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 5.89135,
    y1: 46.9251,
    x2: 44.7218,
    y2: 8.09426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 8.27873,
    y1: 49.3543,
    x2: 47.1094,
    y2: 10.5236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 10.0553,
    y1: 51.1625,
    x2: 48.8858,
    y2: 12.3318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 10.4278,
    y1: 51.5412,
    x2: 49.2583,
    y2: 12.7104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 9.3101,
    y1: 50.4043,
    x2: 48.1406,
    y2: 11.5736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 7.10798,
    y1: 48.164,
    x2: 45.9385,
    y2: 9.33331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 4.72059,
    y1: 45.7349,
    x2: 43.5515,
    y2: 6.90403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 2.94378,
    y1: 43.9263,
    x2: 41.7744,
    y2: 5.09542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 2.57116,
    y1: 43.5472,
    x2: 41.4017,
    y2: 4.71653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 3.68908,
    y1: 44.685,
    x2: 42.5196,
    y2: 5.85426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmurgo);
export default __webpack_public_path__ + "static/media/emurgo.d4f77a417d448951c9f4fcc692efb031.svg";
export { ForwardRef as ReactComponent };